// Deterministic avatar color + initials helpers for chat UI (Discord-style).

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

// Returns a deterministic HSL background color based on the user id.
export function getAvatarBgColor(userId: string): string {
  const hue = hashString(userId) % 360;
  return `hsl(${hue}, 60%, 45%)`;
}

// Returns up to 2 uppercase letters from a display name.
// Takes the first letter of the first and last word; if only one word, the
// first two letters of it.
export function getInitials(name: string): string {
  const trimmed = name.trim();
  if (trimmed === '') return '??';

  const parts = trimmed.split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
  return trimmed.substring(0, 2).toUpperCase();
}
